
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, UsuarioActual } from "../login-controlador";

    import password from './login-ingreso-password.vue';
    import usuario from './login-ingreso-usuario.vue';
    import email from './login-ingreso-email.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            usuario,
            email,
            password,
        }
    } )
    export default class Componente extends Vue
    {
        get Controlador() { return Model; }
        get UsuarioActual() { return UsuarioActual; }

        Listo: boolean = false;
        Modo: 'usuario' | 'email' | 'password' = 'usuario';
        async mounted()
        {
            this.Controlador.$on( 'modo', () =>
            {
                this.Modo = this.Controlador.Modo;
                console.log( this.Modo );
            } );
            await this.Controlador.Iniciar();
            this.Listo = true;
        }

    }
